import swal from "sweetalert";
import axiosInstance from "../api";
import { setColorListData, setOccassionList, setSingleOccassion, setSingleSize, setSinlgeColor, setSizeListData } from "../../reusableSlice";


export const getAllOccassion = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/occasions`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setOccassionList(response?.data?.response))
      } else {
        dispatch(setOccassionList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setOccassionList([]))
    }
  };

  export const addOccassion = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/occasions", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/occassion")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const getSingleOccassion = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/occasions/${id}`);
      console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSingleOccassion(response?.data?.response))
      } else {
        dispatch(setSingleOccassion([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleOccassion([]))
    }
  };

  export const updateOneOccassion = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/occasions", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/occassion")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };



 

  export const deleteOneOccassion = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/occasions/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      // setLoading(false);
    }
  };


